import React, { Component } from 'react';
import DocumentUploader from '../dropzone';
import ViewUploadedFiles from '../ViewUploadeFiles';
import { inject, observer } from 'mobx-react';

@inject('businessProfileStore')
@observer
class IncomeStatement extends Component {
  handleRemoveDocument = (e, documentId) => {
    const { businessFinancials } = this.props.businessProfileStore.businessProfile;
    if (businessFinancials && businessFinancials.annualIncomeStatementDocs) {
      const updatedDocs = businessFinancials.annualIncomeStatementDocs.filter(
        document => document.id !== documentId
      );
      this.props.businessProfileStore.businessProfile.businessFinancials.annualIncomeStatementDocs = updatedDocs;
    }
  };

  render() {
    const { businessProfile } = this.props.businessProfileStore;
    const businessFinancials = businessProfile.businessFinancials || {};
    const annualIncomeStatementDocs = businessFinancials.annualIncomeStatementDocs || [];
    const id = businessFinancials._id || businessFinancials.id;

    const MAX_DOCUMENTS = 2;
    const totalDocuments = annualIncomeStatementDocs.length;
    const remainingSlots = MAX_DOCUMENTS - totalDocuments;

    let fileInfo = {};
    if (id) {
      fileInfo = {
        files: [],
        path: '/public/upload',
        refId: id,
        ref: 'businessfinancials',
        source: 'content-manager',
        field: 'annualIncomeStatementDocs'
      };
    }

    return (
      <section className="p-h-15 p-v-20">
        {remainingSlots > 0 && id && (
          <DocumentUploader
            fileData={fileInfo}
            maxFiles={remainingSlots}
            multiple={true}
            inputContent={'Upload Annual Income Statement Documents'}
          />
        )}
        <div className="row justify-content-center mt-2">
          {annualIncomeStatementDocs.length > 0 && (
            <ViewUploadedFiles
              title="Uploaded Documents"
              data={annualIncomeStatementDocs}
              handleRemoveDocument={this.handleRemoveDocument}
            />
          )}
        </div>
      </section>
    );
  }
}
export default IncomeStatement;
